module.exports = __webpack_public_path__ + "img/guide-img-01.56d27920.png";